import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './accordion-tw-styles';

export default class AccordionPanelDetails extends React.Component {
  static propTypes = {
    /**
     * The content of the expansion panel details.
     */
    children: PropTypes.node.isRequired,

    /**
     * @ignore
     */
    className: PropTypes.string,
    accordionStyle: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.shape({
        accordion: PropTypes.object,
        accordionStory: PropTypes.object,
      }),
    ]),
    isExpanded: PropTypes.bool,
    desktopCollapsible: PropTypes.bool,
    smartphoneCollapsible: PropTypes.bool,
    smartphoneWidth: PropTypes.number,
    onCollapse: PropTypes.func,
  };

  static defaultProps = {
    isExpanded: true,
    desktopCollapsible: true,
    smartphoneCollapsible: true,
    smartphoneWidth: 991,
    accordionStyle: styles,
    className: '',
    onCollapse: undefined,
  };

  constructor(props) {
    super(props);
    const { isExpanded: expanded } = props;
    this.state = {
      isExpanded: expanded,
    };
  }

  componentDidMount = () => {
    let width = window.innerWidth;
    const {
      smartphoneWidth,
      smartphoneCollapsible,
      desktopCollapsible,
    } = this.props;
    if (width <= smartphoneWidth) {
      if (smartphoneCollapsible) {
        this.setState({ isExpanded: false });
      }
    }

    if (width > smartphoneWidth) {
      if (desktopCollapsible) {
        this.setState({ isExpanded: false });
      }
    }
  };

  componentWillReceiveProps = nextProps => {
    this.setState({ isExpanded: nextProps.isExpanded });
  };

  render() {
    const { className, accordionStyle, children } = this.props;
    const { isExpanded } = this.state;
    let accordionStyles = {};
    if (accordionStyle !== null) {
      accordionStyles = accordionStyle;
    } else {
      accordionStyles = styles;
    }
    return (
      <div
        className={classNames(accordionStyles.accordion.panelDetail, className)}
        onKeyDown={e => {
          // Only collapse logic: if Enter pressed on last item, call onCollapse
          if (e.key === 'Enter' && this.props.onCollapse) {
            const focusableElements = Array.from(e.currentTarget.querySelectorAll(
              'button:not([disabled]), [href]:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled])'
            ));
            if (focusableElements.length > 0 && document.activeElement === focusableElements[focusableElements.length - 1]) {
              this.props.onCollapse();
            }
          }
        }}
      >
        <div
          className={
            isExpanded
              ? accordionStyles.accordion.expanded
              : accordionStyles.accordion.collapsed
          }
        >
          {children}
        </div>
      </div>
    );
  }
}
